var r={};export{r as __exports};
//# sourceMappingURL=getStorage.js.map
